<template>
  <a-layout>
    <a-layout-header>
      <a id="logo" href="#">
        <img class="logo" src="../assets/logo.png" alt="泸州老窖天府中学" />
      </a>

      <a id="login" @click="toLogin">
        <img class="login" src="../assets/login.png" />
        用户登录
      </a>
    </a-layout-header>
    <a-layout-content>
      <a-row :gutter="[24, 24]">
        <a-col :xxl="5" :lg="6" :md="7">
          <typeTree title="分类名称" @handleClick="handleClick" />
        </a-col>
        <a-col :xxl="19" :lg="18" :md="17">
          <a-spin :spinning="loading">
            <a-card :bordered="false">
              <div class="table-page-search-wrapper">
                <a-form :form="form" layout="inline">
                  <ResourceType
                    ref="resourceType"
                    :list="resourceTypeList"
                    :treeDatas="treeDatas"
                    @handleItem="handleItem"
                    :externalShow="externalShow"
                  />
                  <a-row :gutter="12">
                    <a-col :span="8">
                      <a-form-item label="资源名称">
                        <a-input v-decorator="['fileName']"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="部门名称">
                        <a-input v-decorator="['deptName']"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-item label="上传用户">
                        <a-input v-decorator="['uploadPerson']"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="上传时间">
                        <a-range-picker
                          v-decorator="['times']"
                          valueFormat="YYYY-MM-DD"
                          style="width: 100%; min-width: 100%"
                        ></a-range-picker>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-button type="primary" icon="search" @click="search"
                        >查询
                      </a-button>
                      <a-button
                        type="default"
                        icon="reload"
                        style="margin-left: 8px"
                        @click="handleReset"
                        >重置
                      </a-button>
                    </a-col>
                  </a-row>
                </a-form>
              </div>

              <typeSection
                :items="items"
                @spin="e => (loading = e)"
                @idsChange="idsChange"
              />
              <template>
                <a-pagination
                  v-model="current"
                  :page-size-options="pageSizeOptions"
                  :total="total"
                  show-size-changer
                  :page-size="pageSize"
                  @showSizeChange="onShowSizeChange"
                  @change="onChange"
                >
                  <template slot="buildOptionText" slot-scope="props">
                    <span v-if="props.value !== '50'"
                      >{{ props.value }}条/页</span
                    >
                    <span v-if="props.value === '50'">全部</span>
                  </template>
                </a-pagination>
              </template>
            </a-card>
          </a-spin>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>
<script>
import typeTree from "@/components/TypeTreeNotLog/index";
import typeSection from "@/components/TypeSection/index";
import ResourceType from "./base/allResource/modules/resourceType";
//api
import { findPage, inquireNotLog } from "@/api/base/resource/manager";

export default {
  components: {
    typeTree,
    typeSection,
    ResourceType
  },
  data() {
    return {
      model: {},
      //选择的id串
      ids: "",
      //form
      form: this.$form.createForm(this),
      items: [],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      current: 1,
      pageSize: 10,
      total: 50,
      loading: false,
      first: [],
      second: [],
      thirdly: [],
      fourth: [],
      resourId: "",
      resourceTypeList: [],
      treeDatas: {},
      externalShow: "Y"
    };
  },
  mounted() {
    let params = {
      page: this.current,
      rows: this.pageSize,
      externalShow: "Y"
      // isPreview: 1
    };
    this.initData(params);
  },

  methods: {
    handleItem(rows) {
      console.log("rows", rows);
      this.items = rows;
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
      let params = {
        page: current,
        rows: this.pageSize,
        externalShow: "Y"
      };
      this.initData(params);
    },
    toLogin() {
      this.$router.push({ path: "/user/login" });
    },

    search() {
      // console.log(this.form.getFieldsValue());
      let data = this.form.getFieldsValue();
      if (data.times) {
        data.times = data.times.toString();
      }

      let params = {
        // keyValue: data.keyValue,
        // times: data.times && data.times.toString(),
        page: 1,
        rows: this.pageSize
        // isPreview: 1
      };
      params = Object.assign(params, data);
      params.resourType = this.resourId;
      this.initData(params);
    },

    onChange(current) {
      console.log(current);
      let params = {
        page: current,
        rows: this.pageSize
      };
      this.initData(params);
    },

    handleClick(id) {
      this.resourId = id;
      this.classification(id);
      // 初始化查询参数
      this.current = 1;
      let params = {
        page: this.current,
        rows: this.pageSize
        // isPreview: 1
      };
      this.treeDatas = params;
      delete this.treeDatas.externalShow;
      console.log("this.treeDatas", this.treeDatas);
      // 如果存在类型id
      if (id) params.resourType = id;
      this.initData({ ...params });
      this.resourceTypeList = [];
      this.$refs.resourceType.resetChildren();
    },

    idsChange(ids) {
      this.ids = ids;
    },

    initData(params) {
      params.externalShow = "Y";
      findPage(params).then(res => {
        this.items = res.result.rows;
        this.total = res.result.records;
        this.current = res.result.page;
        // console.log("最新页码：", this.current);
      });
    },

    // editSubmitSuccess() {
    //   console.log("新增数据");
    //   this.current = 1;
    //   let params = {
    //     page: 1,
    //     rows: this.pageSize,
    //     externalShow: 'Y'
    //   };
    //   this.initData({ ...params });
    // },

    // 查询条件重置
    handleReset() {
      console.log(" === handleReset click === ");
      this.form.resetFields();
    },
    // // 分类展示
    classification(id) {
      inquireNotLog({ partentid: id }).then(res => {
        this.resourceTypeList = res.result[0].jtypes;
        console.log("this.resourceTypeList", this.resourceTypeList);
        this.$refs.resourceType.resetChildren();
      });
    }
  }
};
</script>
<style scoped>
.ant-layout-header {
  color: #fff;
  background: #3880bb;
}
.logo {
  width: 230px;
  height: 70px;
  margin-left: 50px;
  margin-top: -10px;
}
.login {
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 30px;
}
#login {
  float: right;
  color: #fff;
}
.home {
  cursor: pointer;
  margin-left: 15px;
}
.home:hover {
  color: cornflowerblue;
}
</style>
